import styled from '@emotion/styled/macro';
import PropTypes from 'prop-types';

import { colors } from '../../styles/theme';

import { Row } from '../../base';
import { Button } from '../buttons';
import { Input } from '../inputs';
import { Icon } from '../../ui_elements/icons';

const AddFieldsWrapper = styled('div')``;

const FieldsWrapper = styled('div')`
  ${Row} {
    display: flex;
    &:only-child {
      ${Icon} {
        display: none;
      }
    }
  }
  ${Input} {
    order: 1;
  }
  ${Icon} {
    width: 30px;
    order: 2;
    &:hover {
      cursor: pointer;
      & + ${Input} {
        border-color: ${colors.red.primary};
      }
    }
  }
`;

export const AddInputFields = ({ inputProps, value, onChange }) => {
  const handleChange = (str, index) => {
    const newValue = [...value];
    newValue.splice(index, 1, str);
    onChange(newValue);
  };

  const addInput = () => {
    const newValue = [...value];
    newValue.push('');
    onChange(newValue);
  };

  const removeInput = (index) => {
    const newValue = [...value];
    newValue.splice(index, 1);
    onChange(newValue);
  };

  const renderInputs = () => {
    return value.map((val, i) => {
      return (
         
        <Row size="tiny" key={`addable-input-${i}`}>
          <Icon type="x" onClick={() => removeInput(i)} />
          <Input
            {...inputProps}
            onChange={(evt) => handleChange(evt.currentTarget.value, i)}
            value={value[i]}
            id={`${inputProps.id}[${i}]`}
          />
        </Row>
      );
    });
  };

  return (
    <AddFieldsWrapper>
      <FieldsWrapper>{renderInputs()}</FieldsWrapper>

      <Row size="tiny">
        <Button type="button" size="small" variant="secondary" onClick={addInput}>
          <Icon type="plus" withText />
          Add
        </Button>
      </Row>
    </AddFieldsWrapper>
  );
};

AddInputFields.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  inputProps: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
  }).isRequired,
  onChange: PropTypes.func,
};

AddInputFields.defaultProps = {
  value: [''],
  onChange: () => {},
};
